// Plugin to remove leading spaces globally
export default {
  install() {
    let changeEventTriggered = false; // Flag to track if the change event has already been triggered

    document.addEventListener(
      "change",
      function (event) {
        const el = event.target;

        if (
          el.matches(
            "input[type='text'], input[type='email'], input[type='search'], input[type='tel'], input[type='url'], input[type='date'], input[type='month'], input[type='week'], input[type='time'], input[type='datetime-local'], textarea"
          )
        ) {
          const originalValue = el.value;
          const trimmedValue = originalValue.replace(/^\s+/, "");

          if (originalValue !== trimmedValue) {
            el.value = trimmedValue;

            // This triggers Vue to update the model
            el.dispatchEvent(new Event("input", { bubbles: true }));
          }

          if (!changeEventTriggered) {
            console.log("Trimmed leading spaces from input/textarea field");
            changeEventTriggered = true; // Set the flag to true after the first event
          }
        }
      },
      true // Use capture phase
    );
  },
};
